// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetMarkedListRequest, TGetMarkedListModel, IMappers, TGetMarkedListResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetMarkedListV3ResponseSchema } from '../../entities/get_marked_list_v3_response/GetMarkedListV3ResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetMarkedListModel(parameters: TGetMarkedListRequest): TGetMarkedListModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'countryside-search',
    pathApi: '/v3/get-marked-list/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetMarkedListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetMarkedListRequest;
}

export async function fetchGetMarkedList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetMarkedListOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetMarkedListResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetMarkedListModel(parameters),
    config,
  )) as FetchResponse<TGetMarkedListResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetMarkedListV3ResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetMarkedListResponse>;
}
